/**
 * MoneyField writes the raw CurrencyInput value, so a cost can arrive as a string ("100") even where
 * it's typed as a number. The mismatch check compares strictly, so an unchanged cost would otherwise
 * read as a mismatch.
 */
export const getNormalizedPaymentCost = (cost: number | string | null | undefined): number | null => {
    if (cost === null || cost === undefined || String(cost).trim() === '') {
        return null;
    }

    const numericCost = Number(cost);
    if (!Number.isFinite(numericCost)) {
        return null;
    }

    return numericCost;
};

export const isCreatorCostMismatched = (
    creatorCost: number | null,
    creatorCurrencyId: number | null,
    paymentCost: number | null | undefined,
    paymentCurrencyId: number | null | undefined
): boolean => {
    if (paymentCost === null || paymentCost === undefined || !paymentCurrencyId) {
        return false;
    }

    if (creatorCost === null || creatorCurrencyId === null) {
        return true;
    }

    return creatorCost !== paymentCost || creatorCurrencyId !== paymentCurrencyId;
};
